import { ensureTrailingSlash } from '../utils/urlHelper';
import ApiServiceBase from './apiServiceBase';
import { ISaveSettingsRequest, IVocabulariesSettingsResponse } from './models/enrichmentSettings';
import { AxiosRequestConfig, Method } from 'axios';

export default class EnrichmentSettingsApiService extends ApiServiceBase {
	constructor(basePath: string) {
		super(basePath);
	}

	protected createBaseRequest(): AxiosRequestConfig {
		return this.createBaseRequestWith('services/semanticEnrichmentSettings');
	}

	private createBaseRequestWith(path: string): AxiosRequestConfig {
		const baseConfig = super.createBaseRequest();
		return {
			...baseConfig,
			baseURL: ensureTrailingSlash(baseConfig.baseURL) + path
		};
	}

	public async fetchVocabularies(): Promise<IVocabulariesSettingsResponse> {
		const request = {
			url: '/FetchVocabularies',
			method: 'get' as Method,
			...this.createBaseRequest()
		};

		const response = await super.sendAsync<IVocabulariesSettingsResponse>(request);
		this.throwIfFailedResponse(response, localize('Error while fetching semantic vocabularies.'));

		return response.data ?? null;
	}

	public async saveSettings(data: ISaveSettingsRequest): Promise<boolean> {
		const request = {
			url: '/Save',
			method: 'post' as Method,
			data,
			...this.createBaseRequest()
		};

		const response = await super.sendAsync<void>(request);
		this.throwIfFailedResponse(response, localize('Error while saving enrichment settings.'));

		return true;
	}

	public async enableSemanticEnrichment(): Promise<boolean> {
		const request = {
			url: '/GetDocEnrichmentStatus',
			method: 'get' as Method,
			...this.createBaseRequestWith('services/Enrichment')
		};

		const response = await super.sendAsync<void>(request);
		this.throwIfFailedResponse(response, localize('Error while enabling semantic enrichment.'));

		return true;
	}
}
